import {client} from './client';

class problemTypesApi {
    static async getAll(onlyActive) {
        // Default value is true
        let url = '/problem_types';
        url += typeof onlyActive !== 'boolean' ? '?onlyActive=true' : '?onlyActive=false';
        let problems = await client.get(url);
        return problems.data;
    }

    static async getByGroup(groupId) {
        if(/\d+/.test(groupId)) {
            let problems = await client.get('/problem_types?group='+groupId);
            return problems.data;
        } else {
            return [];
        }
    }

    static async getAllWithoutGroup() {
        let problems = await client.get('/problem_types_without_group');
        return problems.data;
    }

    static async save(data) {
        let objectType = await client.put('/problem_types', data);
        return objectType.data;
    }

    static async list(params) {
        let response = await client.get('/problem_types/list', {params});
        return response.data;
    }

    static async show(id) {
        let response = await client.get('/problem_types/' + id);
        return response.data;
    }

    static async create(model) {
        let response = await client.post('/problem_types', model);
        return response.data;
    }

    static async update(model) {
        let response = await client.patch('/problem_types/' + model.id, model);
        return response.data;
    }

    static async delete(id) {
        let response = await client.delete('/problem_types/' + id);
        return response.data;
    }
}

export default problemTypesApi;
